import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import template from './store-profiles.html';

@Inject('$ngRedux', '$state')
class StoreProfilesController {
  onRetailerClick({ id }) {
    this.$state.go('dashboard-view-storeprofiles-summary', { retailerNo: id });
  }
}

class StoreProfilesComponent {
  constructor() {
    this.template = template;
    this.controller = StoreProfilesController;
    return this;
  }
}

export default angular
  .module('store-profiles', ['dashboard'])
  .component('storeProfiles', new StoreProfilesComponent())
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider.state('storeProfiles-view', {
        parent: 'arw',
        url: '/store-profiles',
        template: '<store-profiles></store-profiles>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Store Profiles')));
            },
          ],
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/store-profiles/store-profiles-component.js